<script>
import Player from '@vimeo/player';
export default {
    props: ['videoId', 'provider'],
    data() {
        return {
            videoPlaying: false,
            video: null
        }
    },
    mounted() {
        let self = this;
        if (this.provider == 'wistia') {
            this.initWistia();
        } else if (this.provider == 'vimeo') {
            this.initVimeo();
        }
    },
    methods: {

        initWistia() {
            _wq.push({
                id: this.videoId,
                options: {

                },
                onReady: video => {
                    self.video = video;
                }
            });
        },

        initVimeo() {
            let options = {
                id: this.videoId
            };
            let player = new Player(this.$refs.video, options);
        },
        playVideo() {
            if (this.video.state() === "playing") {
                this.videoPlaying = false;
                this.video.pause();
            } else {
                this.videoPlaying = true;
                this.video.play();
            }
        },
        closeVideo() {
            this.videoPlaying = false;
            this.video.pause();
        }
    }
}
</script>